var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65294 0V2.38783H0.318848V25.4692H8.65409V20.6945H12.8225V25.4692H21.1577V2.38783H17.8229V0H3.65294ZM14.4897 7.95942H16.9903V5.5716H14.4897V7.95942ZM9.48761 7.95942H11.9889V5.5716H9.48761V7.95942ZM4.48742 7.95942H6.98799V5.5716H4.48742V7.95942ZM14.4897 12.736H16.9903V10.3472H14.4897V12.736ZM9.48761 12.736H11.9889V10.3472H9.48761V12.736ZM4.48742 12.736H6.98799V10.3472H4.48742V12.736ZM14.4897 17.5107H16.9903V15.1229H14.4897V17.5107ZM9.48761 17.5107H11.9889V15.1229H9.48761V17.5107ZM4.48742 17.5107H6.98799V15.1229H4.48742V17.5107Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecture);
export default __webpack_public_path__ + "static/media/architecture.c3502c854f03897dfb4d43c752361aeb.svg";
export { ForwardRef as ReactComponent };